import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {Link} from 'shells/link/link';

import {CreateFormOpenButton} from '../creator/create-form-open-button';

import {VisualPipelineColumnHeaderPlaceholder} from './column/visual-pipeline-column-header-placeholder';
import {VisualPipelineColumnPlaceholder} from './column/visual-pipeline-column-placeholder';

import styles from './visual-pipeline.module.css';

type Props = {
    errorMessage?: string;
    isLoading: boolean;
    onErrorRetry: () => any;
    containerStyle: {
        width: number;
        height: number;
    };
};

const DEFAULT_WIDTH = 1200;
const FAKE_STAGES = [0, 1, 2, 3];

export class VisualPipelineEmptyContainer extends React.PureComponent<Props> {
    render() {
        if (this.props.errorMessage) {
            return (
                <div style={this.props.containerStyle} className={styles['empty-container']}>
                    <img
                        src='/include/images/dashboard/list-summary-error_2x.png'
                        className={styles['error-image']}
                    />
                    <div className={styles['error-text']}>{this.props.errorMessage}</div>
                    <Button size='big' onClick={this.props.onErrorRetry}>
                        Try again
                    </Button>
                </div>
            );
        }

        return (
            <div style={this.props.containerStyle} className={styles.container}>
                <div style={{width: DEFAULT_WIDTH}} className={styles['headers-container']}>
                    {FAKE_STAGES.map((index) => {
                        return (
                            <VisualPipelineColumnHeaderPlaceholder
                                key={index}
                                zIndex={FAKE_STAGES.length - index}
                                isLastChild={index === FAKE_STAGES.length - 1}
                            />
                        );
                    })}
                </div>
                <div className={styles['placeholder-container']}>
                    {FAKE_STAGES.map((index) => {
                        return <VisualPipelineColumnPlaceholder key={index} />;
                    })}
                </div>
                <div style={{width: DEFAULT_WIDTH}} className={styles['empty-stages-overlay']}>
                    {this.props.isLoading ? (
                        <LoadingIcon />
                    ) : (
                        <div className={styles['empty-state']}>
                            <img src='/include/images/entity-lists/empty-state/lead_board.png' />
                            <p>Create leads to keep track of new opportunities and customers</p>
                            <div className={styles['action-buttons']}>
                                <CreateFormOpenButton type='leads' />
                                <Link variant='button-primary' size='big' href='/setup/import'>
                                    Import your leads
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
